import React, { useMemo } from 'react';
import { makeStyles, RadioButtonGroup } from "../../../../index";
import { PmlAssignmentCourseContents } from "./PmlAssignmentCourseContents";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: '100%',
        display: 'block',
        padding: theme.spacing(3),
        overflowY: 'scroll',
        backgroundColor: function (props) {
            return props.kind === 'KEYBOARD' ? '#fff3cd' : '#cbf6cb';
        },
    },
    courseGroup: {
        marginBottom: theme.spacing(2),
    },
}); });
/**
 * 情報活用系課題選択ダイアログの表示コンテンツのコンポーネント
 */
export var PmlAssignmentDialogContents = function (props) {
    var courseInfo = props.courseInfo, kind = props.kind, onSelectCourse = props.onSelectCourse, selectedCourseId = props.selectedCourseId, viewMoralContentForMiddleSchool = props.viewMoralContentForMiddleSchool;
    var classes = useStyles(props);
    var _a = useMemo(function () {
        var targetId = selectedCourseId !== null && selectedCourseId !== void 0 ? selectedCourseId : courseInfo.defaultGroupId;
        if (targetId) {
            for (var i = 0; i < courseInfo.courses.length; i++) {
                var course = courseInfo.courses[i];
                var foundGroupIndex = course.groups.findIndex(function (group) {
                    return group.groupId === targetId || group.stages.some(function (stage) { return stage.id === selectedCourseId; });
                });
                if (foundGroupIndex >= 0) {
                    return [i, foundGroupIndex];
                }
            }
            // ここにはこないはず。
            return [-1, -1];
        }
        // コース未選択でデフォルトオープンのグループが指定されていない場合は、一つ目のグループをオープン対象とする。
        return [0, 0];
    }, [courseInfo.courses, courseInfo.defaultGroupId, selectedCourseId]), defaultOpenCourseIndex = _a[0], defaultOpenGroupIndex = _a[1];
    return (React.createElement(RadioButtonGroup, { className: classes.root, direction: 'column', value: selectedCourseId !== null && selectedCourseId !== void 0 ? selectedCourseId : '' }, courseInfo &&
        courseInfo.courses.map(function (course, index) {
            return (React.createElement(PmlAssignmentCourseContents, { className: classes.courseGroup, courseIndex: index, defaultOpenIndex: defaultOpenCourseIndex === index ? defaultOpenGroupIndex : -1, groups: course.groups, key: index, kind: kind, onSelectCourse: onSelectCourse, title: course.courseTitle, viewMoralContentForMiddleSchool: viewMoralContentForMiddleSchool }));
        })));
};
